import { defineEntity, custom } from './_helpers.js';

export default defineEntity('training', {
    assigned:  custom({ scope: 'state' }),
    completed: custom({ scope: 'state' }),
    overdue:   custom({ scope: 'state' }),
});
